import { RoleModuleConfig } from './types';
import { ValidationSpecialistSubjectsSlice } from '@restore/ValidationSpecialistSubjects/ValidationSpecialistSubjects.slice';
import { ValidationSpecialistQuestionnairesSlice } from '@restore/ValidationSpecialistQuestionnaires/ValidationSpecialistQuestionnaires.slice';

import { ValidationSpecialistSubjectsSaga } from '@restore/ValidationSpecialistSubjects/ValidationSpecialistSubjects.saga';
import { ValidationSpecialistQuestionnairesSaga } from '@restore/ValidationSpecialistQuestionnaires/ValidationSpecialistQuestionnaires.saga';

export const validationSpecialistModules: RoleModuleConfig = {
  slices: [
    ValidationSpecialistSubjectsSlice,
    ValidationSpecialistQuestionnairesSlice,
  ],
  sagas: {
    ValidationSpecialistSubjectsSaga,
    ValidationSpecialistQuestionnairesSaga,
  },
};
